import { AuthType } from "./auth.type";
const INITIAL_STATE = {

   isAuth:false,
   isProfile:false,
   isAccess:false,
   callBackUrl:''

};


const authReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
     

        case AuthType.setAuth:
            return {
                    ...state,
                    isAuth: action.payload,
            };

                case AuthType.setProfile:
                return {
                        ...state,
                        isProfile: action.payload,
                };  
                case AuthType.setAccessDashBoard:
                return {
                        ...state,
                        isAccess: action.payload,
                };  
                case AuthType.setCallBackUrl:
                    return {
                        ...state,
                        callBackUrl: action.payload,
                };  

            case AuthType.RESETAUTH:
                return INITIAL_STATE;
                                                               
            default:
                return state;
        }
    };
    
    export default authReducer; 